import { TooltipHost } from '@fluentui/react';
import { IPIconButton, IPStack } from 'baseComponents';
import { leftArrowIcon, rightArrowIcon } from 'globalStyles';
import { useTranslation } from 'react-i18next';

interface IPrevNextButtonsProps {
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  height?: number | string;
  prevTooltip?: string;
  nextTooltip?: string;
  onPrevClick: () => void;
  onNextClick: () => void;
}

export const PrevNextButtons = (props: IPrevNextButtonsProps) => {
  const { t } = useTranslation(['translation', 'control']);

  //
  // Main render
  //
  return (
    <IPStack horizontal verticalAlign="center">
      <IPStack.Item>
        <TooltipHost content={props.prevTooltip ?? t('control:TabDetails.Commands.Prev')}>
          <IPIconButton
            iconProps={leftArrowIcon}
            onClick={props.onPrevClick}
            disabled={props.prevDisabled}
            styles={{ root: { height: props.height } }}
          />
        </TooltipHost>
      </IPStack.Item>
      <IPStack.Item>
        <TooltipHost content={props.nextTooltip ?? t('control:TabDetails.Commands.Next')}>
          <IPIconButton
            iconProps={rightArrowIcon}
            onClick={props.onNextClick}
            disabled={props.nextDisabled}
            styles={{ root: { height: props.height } }}
          />
        </TooltipHost>
      </IPStack.Item>
    </IPStack>
  );
};
